import type { DeepPartial } from 'react-hook-form';

import type { IncompleteEventFormComplete } from '../../../forms/event/IncompleteEventForm/schema.ts';
import { notEmpty } from '../../../lib/notEmpty.ts';
import { removeUndefinedValues } from '../../../lib/removeUndefinedValues.ts';
import { mapAdditionalDetailsToEventDetails } from '../../../mappers/incompleteEvent/formToApi/lib/mapAdditionalDetailsToEventDetails.ts';
import { mapTagsToTargetAudiences } from '../../../mappers/incompleteEvent/formToApi/lib/mapTagsToTargetAudiences.ts';
import { parseIsoDate } from '../../../mappers/incompleteEvent/formToApi/lib/parseIsoDate.ts';
import { parseOnlineLink } from '../../../mappers/incompleteEvent/formToApi/lib/parseOnlineLink.ts';
import { parseVenue } from '../../../mappers/incompleteEvent/formToApi/lib/parseVenue.ts';
import { parseFormValue } from '../../../mappers/lib/parseFormValue.ts';
import type { IncompleteEventApiUpdateData } from './types.ts';

export const incompleteEventEditFormToIncompleteEventApi = (
  incompleteEventEditFormValues: DeepPartial<IncompleteEventFormComplete>,
): IncompleteEventApiUpdateData => {
  const target_audiences = incompleteEventEditFormValues.tags
    ? mapTagsToTargetAudiences(incompleteEventEditFormValues.tags.filter(notEmpty))
    : undefined;
  const event_details = incompleteEventEditFormValues.eventDetails
    ? mapAdditionalDetailsToEventDetails(incompleteEventEditFormValues.eventDetails.filter(notEmpty))
    : undefined;

  const type = parseFormValue(incompleteEventEditFormValues.eventType);
  const venue =
    type === 'online' || type === 'secret'
      ? null
      : parseVenue(type ?? undefined, incompleteEventEditFormValues.venue ?? undefined);

  const data: Record<string, unknown> = {
    description: incompleteEventEditFormValues.description ?? undefined,
    name: parseFormValue(incompleteEventEditFormValues.name),
    category: incompleteEventEditFormValues.category
      ? Number.parseInt(incompleteEventEditFormValues.category, 10)
      : undefined,
    target_audiences,
    event_details,
    type,
    venue,
    online_link: parseOnlineLink(incompleteEventEditFormValues.eventType, incompleteEventEditFormValues.onlineLink),
    custom_venue: parseFormValue(incompleteEventEditFormValues.customVenue),
    image: parseFormValue(incompleteEventEditFormValues.image),
    image_original: parseFormValue(incompleteEventEditFormValues.image_original),
    image_crop_data: incompleteEventEditFormValues.image_crop_data ?? null,
    website_link: parseFormValue(incompleteEventEditFormValues.websiteLink),
    instagram_link: parseFormValue(incompleteEventEditFormValues.instagramLink),
    tiktok_link: parseFormValue(incompleteEventEditFormValues.tiktokLink),
    spotify_link: parseFormValue(incompleteEventEditFormValues.spotifyLink),
    start: parseIsoDate(incompleteEventEditFormValues.start),
    end: parseIsoDate(incompleteEventEditFormValues.end),
    recurrence_rate: parseFormValue(incompleteEventEditFormValues.recurrenceRate),
    recurrence_active: parseFormValue(incompleteEventEditFormValues.recurrenceActive),
    recurrence_duration_option: incompleteEventEditFormValues.recurrenceDurationOption,
    recurrence_month_type: incompleteEventEditFormValues.recurrenceMonthType,
    recurrence_amount: incompleteEventEditFormValues.recurrenceAmount,
    ticket_sale_url: parseFormValue(incompleteEventEditFormValues.ticketshopLink),
  };

  return removeUndefinedValues(data);
};
